<template>
  <div class="timedSpecials">
    <page-template
      ref="timeSpecialTable"
      :tableOptions='tableOptions'
      :searchOptions='searchOptions'
      :toolConfig='toolConfig'
      :addColumns='addColumns'
    ></page-template>
    <el-dialog
      :title="dialogTitle+title"
      :visible.sync="timedSpecialsVisible"
      center
      custom-class='timedSpecialsBox'
      width="900px"
      :before-close="closeDialog"
    >
      <el-form ref="timeSpcecailsForm" label-width="10%"  :rules="rules" :model="timeSpcecailsFormData">
        <el-collapse v-model="activeName">
          <!-- 折叠面板一 -->
          <el-collapse-item title="基础信息" name="1">
            <el-form-item label='活动名称' prop="activityName">
              <el-input v-model="timeSpcecailsFormData.activityName" placeholder='请输入活动名称' :disabled="isView"></el-input>
            </el-form-item>
            <el-form-item label='活动时间' prop="nStartTime">
              <div>
                <el-date-picker
                  value-format='yyyy-MM-dd HH:mm:ss'
                  v-model="timeSpcecailsFormData.nStartTime"
                  type="datetime"
                  default-time="00:00:00"
                  @change="changeTime($event, 'start')"
                  :picker-options="pickerOptionsRange"
                  :disabled="editDisabled"
                  placeholder="选择日期时间">
                </el-date-picker>
                至
                <el-date-picker
                  value-format='yyyy-MM-dd HH:mm:ss'
                  v-model="timeSpcecailsFormData.nEndTime"
                  type="datetime"
                  default-time="23:59:59"
                  @change="changeTime($event, 'end')"
                  :picker-options="pickerOptionsRange"
                  :disabled="editDisabled"
                  placeholder="选择日期时间">
                </el-date-picker>
              </div>
            </el-form-item>
            <el-form-item label='适用门店'>
              <el-radio-group v-model="timeSpcecailsFormData.storesType" :disabled="isView">
                <el-radio :label="0">全部门店</el-radio>
                <el-radio :label="1">指定门店</el-radio>
              </el-radio-group>
            </el-form-item>
            <!-- "指定门店"时显示 -->
            <!--                <div v-if="timeSpcecailsFormData.storesType==='1'" class="someStores">-->
            <!--                    <SimpleTable :tableStyleName='"dialogTable"' :tableOperates='tableOperates' :tableDataTitle='tableDataTitle' :tableDataP='tableDataP'-->
            <!--                      @btnCallback='btnCallback'-->
            <!--                    ></SimpleTable>-->
            <!--                </div>-->
            <!--                  <el-option label='全部门店' value='0'></el-option>-->
            <!--                   <el-option label='指定门店' value='1' @click.native="selectStoresVisible=true"></el-option>-->
            <el-form-item label="指定门店" :prop="timeSpcecailsFormData.storesType=='1'?'seStoreIds':''"  v-if="timeSpcecailsFormData.storesType=='1'">
              <el-select v-model="timeSpcecailsFormData.seStoreIds" :disabled="isView" multiple>
                <el-option
                  v-for="(item,index) in storeOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label='适用渠道'>
              <el-radio-group size="mini" v-model="timeSpcecailsFormData.channelHow" :disabled="isView">
                <el-radio-button label="A01" >全部</el-radio-button>
                <el-radio-button label="A02" >线上</el-radio-button>
                <el-radio-button label="A03" >线下</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label='适用人群'>
              <el-radio-group size="mini" v-model="timeSpcecailsFormData.applicableWho" :disabled="isView">
                <el-radio-button :label="item.id" :key="index" v-for="(item,index) in timeSpcecailsFormData.applicablePeople">{{item.label}}</el-radio-button>
              </el-radio-group>
              <el-select v-if="timeSpcecailsFormData.applicableWho=='A03'" v-model="timeSpcecailsFormData.applicableMember">
                <el-option :label='item.label' :value='item.id' :key="index" v-for="(item,index) in timeSpcecailsFormData.members"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label='购买限制'>
              <el-radio-group size="mini" v-model="timeSpcecailsFormData.puchaseWhat" :disabled="isView">
                <el-radio-button :label="item.id" :key="index" v-for="(item,index) in timeSpcecailsFormData.puchaseLimits">{{item.label}}</el-radio-button>
              </el-radio-group>
              <el-input-number v-if="timeSpcecailsFormData.puchaseWhat==='A02'" v-model="timeSpcecailsFormData.puchaseCount" placeholder='请输入数字'></el-input-number>
            </el-form-item>
            <el-form-item label='会员积分'>
              <el-radio-group size="mini" v-model="timeSpcecailsFormData.isIntegral" :disabled="isView">
                <el-radio-button label="A01">积分</el-radio-button>
                <el-radio-button label="A02">不积分</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label='活动说明'>
              <el-input
                style="width:50%;margin-bottom:20px"
                type="textarea"
                :rows="2"
                placeholder="请输入活动内容"
                v-model="timeSpcecailsFormData.descripActivity"
                maxlength="200"
                :disabled="isView"
                show-word-limit>
              </el-input>
            </el-form-item>
          </el-collapse-item>
          <!-- 折叠面板二 -->
          <el-collapse-item title="参与商品及特价设置" name="2">
            <el-form-item label='参与商品'>
              <el-radio-group size="mini" v-model="timeSpcecailsFormData.participateWhat" :disabled="isView">
                <el-radio-button :label="item.id" :key="index" v-for="(item,index) in timeSpcecailsFormData.participateTypes" @click.native="participateWhatClick($event.target.tagName,item,'participate')">{{item.label}}</el-radio-button>
              </el-radio-group>
              <!-- "指定分类"时显示 -->
              <div v-if='timeSpcecailsFormData.participateWhat==="A02"' class="takepartClassify">
                <div class="classifyTree">
                  <el-tree
                    ref="treeForm"
                    :check-strictly='true'
                    :check-on-click-node='true'
                    :data="timeSpcecailsFormData.takepartClassify"
                    show-checkbox
                    node-key="value"
                    :default-checked-keys="timeSpcecailsFormData.treeChecked"
                    :props="defaultTreeProps"
                    @check='getCurrentNodes'>
                  </el-tree>
                </div>
                <SimpleTable style="margin-top:10px;margin-bottom:30px" :tableStyleName='"dialogTable"' :tableOperates='tableOperates2' :tableDataTitle='tableClassifyTitle' :tableDataP='tableClassifyData'
                             @btnCallback='btnCallback2'>
                  <el-table-column slot="promotionSale" prop="promotionSale" label="促销价格(特价)">
                    <template slot-scope="scope">
                      <el-input-number v-model="scope.row.promotionSale" :min='0.00' :max='9.99'  placeholder='0.00'></el-input-number>
                    </template>
                  </el-table-column>
                </SimpleTable>
              </div>
              <!-- 选择的"指定商品"列表 -->
              <div v-if='timeSpcecailsFormData.participateWhat==="A03"' class="takepartGoods">
                <SimpleTable style="margin-top:10px;margin-bottom:30px" :tableStyleName='"dialogTable"' :tableOperates='tableOperates3' :tableDataTitle='tableGoodsTitle' :tableDataP='tableinGoodsData'
                             @btnCallback='btnCallback3'>
                  <el-table-column slot="promotionSale" prop="promotionSale" label="促销价格(特价)">
                    <template slot-scope="scope">
                      <el-input-number v-model="scope.row.promotionSale" :min='0.00' :max='9.99'  placeholder='0.00'  @change="numberInputChange(scope.row)"></el-input-number>
                    </template>
                  </el-table-column>
                </SimpleTable>
              </div>
            </el-form-item>
            <!-- 参与商品为"指定商品"时不显示 -->
            <el-form-item v-if="timeSpcecailsFormData.participateWhat!='A03'" label='不参与商品'>
              <el-radio-group size="mini" v-model="timeSpcecailsFormData.noparticipateWhat" :disabled="isView">
                <el-radio-button :label="item.id" :key="index" v-for="(item,index) in timeSpcecailsFormData.noparticipateTypes" @click.native="participateWhatClick($event.target.tagName,item,'noparticipate')">{{item.label}}</el-radio-button>
              </el-radio-group>
              <!-- 不参与商品以分类为依据时显示 -->
              <div v-if="timeSpcecailsFormData.noparticipateWhat==='A02'" class="notakepartClassify">
                <div class="classifyTree">
                  <el-tree
                    ref="treeForm"
                    :check-strictly='true'
                    :data="timeSpcecailsFormData.takepartClassify"
                    show-checkbox
                    node-key="value"
                    :default-checked-keys="timeSpcecailsFormData.notreeChecked"
                    :props="defaultTreeProps"
                    @check='getCurrentNodesNoPart'>
                  </el-tree>
                </div>
              </div>
              <!-- 不参与商品为"指定商品"时显示 -->
              <div v-if='timeSpcecailsFormData.noparticipateWhat==="A03"' class="takepartGoods">
                <SimpleTable style="margin-top:10px;margin-bottom:30px" :tableStyleName='"dialogTable"' :tableOperates='tableOperates4' :tableDataTitle='tablenoGoodsTitle' :tableDataP='tablenoGoodsData'
                             @btnCallback='btnCallback4'>
                  <el-table-column slot="promotionSale" prop="promotionSale" label="促销价格(特价)">
                    <template slot-scope="scope">
                      <el-input-number v-model="scope.row.promotionSale"  placeholder='0.00'></el-input-number>
                    </template>
                  </el-table-column>
                </SimpleTable>
              </div>
            </el-form-item>
            <el-form-item label='优惠层级'>
              <div class="preferentialLevels"  :key="index" v-for="(item,index) in timeSpcecailsFormData.detailList">
                <span style="margin-right:5px">满</span>
                <div class="iconArea">￥</div>
                <el-input-number placeholder="请输入内容" v-model="item.maxNum" type="number" :min="0" :disabled="isView">
                </el-input-number>
                <span style="margin-left:10px;margin-right:5px">减</span>
                <div class="iconArea">￥</div>
                <el-input-number placeholder="请输入内容" v-model="item.subtractNum" type="number" :min="0" :disabled="isView">
                </el-input-number>
                <el-button v-if="timeSpcecailsFormData.detailList.length>1&&!isView" @click="timeSpcecailsFormData.detailList.splice(index,1)" style="margin-left:10px" type='danger'>删除</el-button>
                <el-button v-if='(timeSpcecailsFormData.detailList.length==1||index==timeSpcecailsFormData.detailList.length-1)&&!isView' type='primary' @click="addPreferentialLevels">新增</el-button>
              </div>
            </el-form-item>
          </el-collapse-item>
        </el-collapse>
      </el-form>
      <div class="footerBtn" v-if="!isView">
        <el-button type='primary' @click="save()">保存</el-button>
        <el-button type='default' @click="reset()">重置</el-button>
      </div>
    </el-dialog>
    <SelectStoresDialog v-if='selectStoresVisible' :lastTableData.sync='tableDataP' :lastFormModel.sync='timeSpcecailsFormData' :selectStoresVisible.sync='selectStoresVisible'></SelectStoresDialog>
<!--    指定商品弹框-->
    <SelectGoodsDialog v-if="selectGoodsVisible" :lastTableData.sync='tableGoodsData' :searchParams="searchParams"
                       :selectGoodsVisible.sync='selectGoodsVisible' :isParticipate="isParticipate"
                       :selectGoods="selectGoods"></SelectGoodsDialog>
  </div>
</template>

<script>
import SimpleTable from '@/components/template/simpleTable'
import SelectStoresDialog from './SelectStoresDialog.vue'
import SelectGoodsDialog from './SelectGoodsDialog.vue'
import api from '@/config/api'
export default {
  data(){
    const valTowValue = (rule,value,callback)=>{
      if(value == '' || value == null){
        callback(new Error('请选择开始日期'))
      }else if(this.timeSpcecailsFormData.nEndTime == '' || this.timeSpcecailsFormData.nEndTime == 'null'){
        callback(new Error('请选择结束日期'))
      }else{
        callback()
      }
    }
    return {
      selectGoods: [],
      isView: false,
      isParticipate: '',
      editDisabled: false,
      pickerOptionsRange: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      searchParams: {
        stCreateDttm: '',
        edCreateDttm:''
      },
      rules:{
        activityName: { required: true, message: "请填写活动名称", trigger: "blur" },
        nStartTime:{ required: true,validator:valTowValue, message: "请选择时间", trigger: "change" },
        nEndTime:{required: true, message: "请选择时间", trigger: "blur" },
        seStoreIds:{required: true, message: "请选择指定门店", trigger: "change" },
      },
      id:0,
      dialogTitle:'',
      activityType:30,
      formPurpose:'add',//表单打开目的
      currentRowId:-1,//表格行Id
      activeName:['1','2'],
      checkList:[],
      enumerationMembers:[],
      enumerationTakepartClassify:[],
      enumerationAssignClassifys:[],
      storeOptions:[],
      timeSpcecailsFormData:{
        activityName:'',
        checkedCycle:false,
        nStartTime:'',
        nEndTime:'',
        startTime:'',
        endTime:'',
        rangeTimes:[
          {
            startTime:'',
            endTime:'',
          },
          {
            startTime:'',
            endTime:'',
          }
        ],
        detailList:[
          {maxNum:0,subtractNum:0}
        ],
        cycleExe:'',
        everyWhat:'',//默认打开周期显示每天
        storesType:0,//适用门店默认全部门店
        channelHow:'A03',//适用渠道，默认线下
        applicableWho:'A01',//普适，默认全部用户
        applicableMember:'',//仅适用会员时选的会员
        puchaseWhat:'A01',//购买限制如何，默认不限
        puchaseCount:Number('0'),//每人限购个数
        isListDiscount:false,//是否整单折扣
        isIntegral:'A01',//是否会员积分默认积分
        descripActivity:'这是活动说明',//活动说明
        participateWhat:'A01',//参与的商品radio,默认全部商品
        retailPrice:1128,//统一零售价
        noparticipateWhat:'A01',//不参与的商品radio，默认无
        takepartClassify:[
          {
            value: 1,
            label: '一级 1',
            children: [{
              value: 4,
              label: '二级 1-1',
              children: [{
                value: 9,
                label: '三级 1-1-1'
              }, {
                value: 10,
                label: '三级 1-1-2'
              }]
            }]
          }
        ],//用户选择的分类
        treeChecked:[],//树状选中的所有
        notreeChecked:[],//不参与类别的树状数据
        applicablePeople:[//适用人群可选项
          {
            label:'全部用户',
            id:'A01'
          },
          {
            label:'普通用户',
            id:'A02'
          },{
            label:'仅会员',
            id:'A03'
          },
        ],
        members:[//适用会员可选项
          {label:'普通会员',id:'B01'},
          {label:'高级会员',id:'B02'}
        ],
        puchaseLimits:[
          {
            label:'不限',
            id:'A01'
          },
          {
            label:'每人每单每个商品限购(件/kg/箱)',
            id:'A02'
          }
        ],
        participateTypes:[
          // {label:'全部商品',id:'A01'},
          // {label:'指定分类',id:'A02'},
          {label:'指定商品',id:'A03'},
        ],
        noparticipateTypes:[
          {label:'无',id:'A01'},
          {label:'指定分类',id:'A02'},
          {label:'指定商品',id:'A03'},
        ],
        assignClassifys:[
          {
            value:'A01',
            label:'生鲜水果',
            children:[],
            classifyName:'生鲜水果',
            promotionSale:Number('100')
          }
        ]
      },
      defaultTreeProps:{
        children: 'children',
        label: 'label'
      },
      timedSpecialsVisible:false,
      selectStoresVisible:false,//选择门店dialog
      selectGoodsVisible:false,//选择商品dialog
      title:'满减活动',
      // 高级搜索条件
      searchOptions: {
        simple: [
          {
            label: '',
            type: 'input',
            prop: 'name',
            isFuzzy: true,
            placeholder: '请输入活动名称',
          }
        ],
        complex: [
          {
            label: '选择日期',
            prop: 'CreateDttm',
            type: 'dateTimeRangeButton',
            dateType: 'datetime',
            span: 24,
          },
          {
            label: '活动状态',
            type: 'select',
            prop: 'status',
            data: this.$utils.getCacheStatus('mkActivity.status'),
            // data: [
            //   {
            //     label:'未开始',
            //     value:0,
            //   },
            //   {
            //     label:'进行中',
            //     value:1
            //   },
            //   {
            //     label:'已结束',
            //     value:2
            //   },
            //   {
            //     label:'被终止',
            //     value:3
            //   }
            // ],
            span: 24,
            // param: {type: 40},
            // url: api.system.type,
          },
          {
            label: '适用渠道',
            prop: 'ddddd',
            type: 'radio',
            data:[
              {
                label:'全部',
                name:''
              },
              {
                label:'线上',
                name:123
              },
              {
                label:'线下',
                name:321
              },
            ],
            span: 24,
          }
        ]
      },
      // 更多功能
      toolConfig: [
        {
          label:'编辑',
          code:'update',
          callback:this.editPromotion,
          filter: (data) => {
            return data.status == 10 && !this.storeId ? true : false;
            // return (data.status == 10 && data.storeIds) ? true :false
          }
        },
        {
          label:'删除',
          code:'delete',
          filter: (data) => {
            // return (data.status ==10|| data.status ==30 || data.status ==40) && !this.storeId ? true : false;
            return (data.status ==10) && !this.storeId ? true : false;
          }
        },
        {
          label: '终止',
          code:'termination',
          callback:this.stopTermination,
          filter: (data) => {
            return data.status == 20 ? true : false;
          }
        },
        {
          label: '查看详情',
          type: this.$utils.buttonType.tableOperate,
          callback: this.checkGoods,
          code: 'record',
        },
        {
          label: 'wifi打印',
          code: '',
          type: this.$utils.buttonType.tableOperate,
        },
        {
          label: '打印订单',
          code: '',
          type: this.$utils.buttonType.tableOperate,
        },
        {
          label: '设置',
          code: 'set',
        },
        {
          label: '打印',
          code: 'print',
        },
        {
          label: '新增',
          code: 'insert',
          callback: this.addTimedSpecials,
          filter:()=>{
            return this.storeId?false :true
          }
        },
        {
          label: '导出',
          code: 'export',
          callback: this.exportExcel
        }
      ],
      tableOptions:{
        tableName:'timeSpecialTable',
        showSelect: false,
        indexShow: true,//是否显示索引
        indexMethod: (index) => {//自定义列索引
          return index + 1;
        },
        columns: [
          {
            label: "活动名称",
            prop: "name",
            width: "120",
            align: "center",
            code: 'name',
            callback:this.activityView,
          },
          {
            label: "活动类型",
            prop: "activityType",
            width: "120",
            align: "center",
            enumData: this.$utils.getCacheStatus('mkActivity.activityType'),
          },
          {
            label: "开始时间",
            prop: "startTime",
            width: "120",
            align: "center",
          },
          {
            label: "结束时间",
            prop: "endTime",
            width: "120",
            align: "center",
          },
          {
            label: "适用渠道",
            prop: "channelType",
            width: "120",
            align: "center",
            enumData: this.$utils.getCacheStatus('mkActivity.channelType'),
            selfData:'全部',
          },
          {
            label: "活动状态",
            prop: "status",
            width: "120",
            align: "center",
            enumData: this.$utils.getCacheStatus('mkActivity.status'),
          }
        ],
        param:{
          activityType:30,
        },
        url: api.promotion.plan,
      },
      addColumns:{
        labelWidth:'120px',
        columns:[
          {
            label: "手机号",
            type: "input",
            prop: "mobile",
            span: 12,
            rule: [
              {required: true, message: "手机号", trigger: "blur"},
              {pattern: this.$utils.reg.phone, message: "请输入正确的11位手机号码", trigger: 'blur'}
            ]
          },
          {
            label: '适用门店',
            type: 'select',
            prop: 'cashierId',
            data: [],
            span: 12,
            param: {type: 40},
            url: api.system.type,
          }
        ],
      },
      tableDataTitle:[
        {
          label:'门店编号',
          prop:'serialNumber'
        },
        {
          label:'门店名称',
          prop:'storyName'
        },
        {
          label:'门店类型',
          prop:'storesType'
        },
      ],
      tableClassifyTitle:[
        // {label:'分类编号',prop:'classifyNum'},
        {label:'分类名称',prop:'classifyName'},
      ],
      tableGoodsTitle:[
        {label:'序号',prop:'index',width:'60'},
        {label:'条形码',prop:'barCode'},
        {label:'商品名称',prop:'goodsName'},
        {label:'进货价',prop:'purchasingPrice',width:'100'},
        {label:'零售价(元)',prop:'retailPrice',width:'100'},
        // {label:'促销价格(特价)',slot:'promotionSale'}
      ],
      tablenoGoodsTitle:[
        {label:'序号',prop:'index',width:'60'},
        {label:'条形码',prop:'barCode'},
        {label:'商品名称',prop:'goodsName'},
        {label:'进货价',prop:'purchasingPrice',width:'100'},
        {label:'零售价(元)',prop:'retailPrice',width:'100'},
      ],
      tableOperates:['delete','edit'],
      tableOperates2:['delete'],
      tableOperates3:['delete'],
      tableOperates4:['delete'],
      tableDataP:[],
      tableClassifyData:[//表格显示的选择类别
        {
          value:'A01',
          label:'',
          classifyName:'',
          promotionSale:Number('0')
        }
      ],//字段结构等同于takepartClassify。选中分类后展示的表格
      tablenoClassifyData:[],
      tableGoodsData:[],
      tableinGoodsData:[],
      tablenoGoodsData:[],
    }
  },
  watch:{
    'timeSpcecailsFormData.participateWhat':{
      handler(val,old){
        switch (val) {
          case 'A01'://参与商品为“全部”
            this.timeSpcecailsFormData.noparticipateTypes=[
              {label:'无',id:'A01'},
              {label:'指定分类',id:'A02'},
              {label:'指定商品',id:'A03'}
            ]
            break;
          case 'A02'://参与商品为“指定分类”,不参与商品选项改变
            this.timeSpcecailsFormData.noparticipateTypes=[
              {label:'无',id:'A01'},
              {label:'指定商品',id:'A03'}
            ]
            this.timeSpcecailsFormData.noparticipateWhat=this.timeSpcecailsFormData.noparticipateWhat||'A01';//返回了用服务端，没返回默认无
            break;
          case 'A03'://参与商品为“指定商品”

          default:
            break;
        }
      },
      deep:true
    }
  },
  components:{
    SimpleTable,
    SelectStoresDialog,
    SelectGoodsDialog
  },
  created(){
    this.refontSize();
    this.getAllEnumeration();
    this.getStoreOptions()
    this.storeId = JSON.parse(localStorage.getItem('SYSUSER')).storeId
  },
  methods:{
    // 门店
    getStoreOptions(){
      this.$axios.fetchPost(api.system.seStore+'/list',{}).then(res=>{
        // res.data.unshift({name:'全部门店',id:null})
        this.storeOptions = res.data
      })
    },
    // 查看活动
    activityView(row){
      this.isView = true
      this.editDisabled = true
      this.tableOperates3 = null
      this.tableOperates4 = null
      this.editPromotion(row,'查看')
    },

    // 选择日期
    changeTime(val,type){
      if(Date.parse(this.timeSpcecailsFormData.nEndTime)-Date.parse(this.timeSpcecailsFormData.nStartTime)<0){
        this.$message(
          {
            message:'结束时间必须大于开始时间',
            type:'warning'
          }
        )
        if(type == 'start'){
          this.timeSpcecailsFormData.nStartTime = ''
        }else{
          this.timeSpcecailsFormData.nEndTime = ''
        }
      }
    },
    // 关闭弹框
    closeDialog(){
      this.reset()
      this.$refs.timeSpcecailsForm.resetFields() // 清空验证效果
      this.timedSpecialsVisible = false
      this.editDisabled = false
      this.isView = false
      this.tableOperates3 = ['delete']
      this.tableOperates4 = ['delete']
      this.searchParams={
        stCreateDttm:'',
        edCreateDttm:''
      }
    },
    save(){
      this.$refs.timeSpcecailsForm.validate((valid) => {
        if (valid) {
          let url=api.promotion.plan;
          console.log('====',this.timeSpcecailsFormData)
          let data={
            activityType:this.activityType,
            name:this.timeSpcecailsFormData.activityName,
            startTime:this.timeSpcecailsFormData.nStartTime,
            endTime:this.timeSpcecailsFormData.nEndTime,
            openStore:this.timeSpcecailsFormData.storesType==0?false:true,
            seStoreIds:this.timeSpcecailsFormData.storesType==0?null:this.timeSpcecailsFormData.seStoreIds,//选择的门店
            merchantId:this.timeSpcecailsFormData.merchantId,
            storeId:this.timeSpcecailsFormData.storeId,
            storeIds:this.timeSpcecailsFormData.storeIds,//若为空，则是门店自己添加的活动，门店可以删除
            channelType:this.localFieldShift('channelHow'),//10线上，20线下，30全部
            userChannel:this.localFieldShift('applicableWho'),
            openPurchase:this.timeSpcecailsFormData.puchaseWhat==='A01'?false:true,//false不限制
            openIntegral:this.timeSpcecailsFormData.isIntegral==='A01'?false:true,//不积分
            remarks:this.timeSpcecailsFormData.descripActivity,
            participationType:this.localFieldShift('participateWhat'),//10全部商品20指定分类30指定商品
            special:this.timeSpcecailsFormData.retailPrice,//统一零售价
            noParticipationType:this.localFieldShift('noparticipateWhat'),//10无20分类30商品

            // seStoreIds:this.localFieldShift('tableDataP'),//用户选择的门店
            purchaseNum:this.timeSpcecailsFormData.puchaseCount,
            userChannelIds:this.timeSpcecailsFormData.applicableMember,
            categoryList:this.tableClassifyData,
            goodsList:this.tableinGoodsData,
            noCategoryList:this.tablenoClassifyData,
            noGoodsList:this.tablenoGoodsData,
            detailList:this.localFieldShift('detailList')
          }
          let status = true
          data.detailList.forEach(v=>{
            if(Number(v.maxNum)-Number(v.subtractNum)<0 || Number(v.maxNum)-Number(v.subtractNum)==0){
              this.$message(
                {
                  message:'优惠满减金额必须大于0！',
                  type:'warning'
                })
              status = false
            }else{
              status = true
            }
          })
          if(status){
            const loading=this.$loading();
            // 添加与编辑参数相同，编辑多个id参数并且为put请求。
            if(this.formPurpose==='add'){
              this.$axios.fetchPost(url,data).then((res)=>{
                loading.close();
                if(res.code==200){
                  this.$notify({
                    type: "success",
                    title: '保存操作',
                    message: '成功',
                    showClose: false,
                  });
                  // this.$message(
                  //   {
                  //     message:'保存成功',
                  //     type:'success'
                  //   }
                  // )
                  this.closeDialog()
                  //重刷表格数据
                  this.$refs.timeSpecialTable.getData()
                }else{
                  this.$notify({
                    type: "error",
                    title: '保存操作',
                    message: '失败',
                    showClose: false,
                  });
                  // this.$message.error(res.errorMsg || '活动保存失败！')
                }
              })
            }
            if(this.formPurpose==='edit'){
              data.id=this.currentRowId;
              this.$axios.fetchPut(url,data).then((res)=>{
                loading.close();
                if(res.code==200){
                  this.$notify({
                    type: "success",
                    title: '保存操作',
                    message: '成功',
                    showClose: false,
                  });
                  // this.$message(
                  //   {
                  //     message: '保存成功',
                  //     type:'success'
                  //   }
                  // )
                  this.closeDialog()
                  //重刷表格数据
                  this.$refs.timeSpecialTable.getData()
                }else{
                  this.$notify({
                    type: "error",
                    title: '保存操作',
                    message: '失败',
                    showClose: false,
                  });
                  // this.$message.error(res.errorMsg || '活动保存失败！')
                }
              })
            }
          }
        }else{
          return false
        }
      })
    },
    reset(){
      //初始化表单
      this.timeSpcecailsFormData={
        activityName:'',
        checkedCycle:false,
        nStartTime:'',
        nEndTime:'',
        startTime:'',
        endTime:'',
        rangeTimes:[
          {
            startTime:'',
            endTime:'',
          },
          {
            startTime:'',
            endTime:'',
          }
        ],
        detailList:[
          {maxNum:0,subtractNum:0}
        ],
        cycleExe:'',
        everyWhat:'',//默认打开周期显示每天
        storesType:0,//适用门店默认全部门店
        seStoreIds:[],//选择的指定门店
        storeIds:'',//若为空，则是门店自己添加的活动，门店可以删除
        channelHow:'A03',//适用渠道，默认线下
        applicableWho:'A01',//普适，默认全部用户
        applicableMember:'',//仅适用会员时选的会员
        puchaseWhat:'A01',//购买限制如何，默认不限
        puchaseCount:'',//每人限购个数
        isListDiscount:false,//是否整单折扣
        isIntegral:'A01',//是否会员积分
        descripActivity:'',//活动说明
        participateWhat:'A01',//参与的商品radio,默认全部商品
        retailPrice:Number('0'),//统一零售价
        noparticipateWhat:'A01',//不参与的商品radio，默认无
        takepartClassify:this.enumerationTakepartClassify,//用户可选择的分类
        treeChecked:[],//树状选中的所有
        notreeChecked:[],//不参与类别的树状数据
        applicablePeople:[//适用人群可选项
          {
            label:'全部用户',
            id:'A01'
          },
          {
            label:'普通用户',
            id:'A02'
          },{
            label:'仅会员',
            id:'A03'
          },
        ],
        members:this.enumerationMembers,//适用会员可选项
        puchaseLimits:[
          {
            label:'不限',
            id:'A01'
          },
          {
            label:'每人每单每个商品限购(件/kg/箱)',
            id:'A02'
          }
        ],
        participateTypes:[
          // {label:'全部商品',id:'A01'},
          // {label:'指定分类',id:'A02'},
          {label:'指定商品',id:'A03'},
        ],
        noparticipateTypes:[
          {label:'无',id:'A01'},
          {label:'指定分类',id:'A02'},
          {label:'指定商品',id:'A03'},
        ],
        assignClassifys:this.enumerationAssignClassifys,
        // {
        //   value:'',
        //   label:'',
        //   classifyNum:'',
        //   classifyName:'',
        //   numberGoods:'',
        //   promotionSale:Number('0')
        // }

      };
      this.tableinGoodsData=[];
      this.tableClassifyData=[];
      this.tableGoodsData=[];
    },
    //获取树状节点数据
    getCurrentNodes(currentClickNode,{checkedNodes}){
      if(this.formPurpose=='add'){
        this.tableClassifyData=[];
        this.timeSpcecailsFormData.treeChecked=[];
        for(let i=0;i<checkedNodes.length;i++){
          let objectAdaptor={
            value:checkedNodes[i].value,
            label:checkedNodes[i].label,
            classifyName:checkedNodes[i].label
          }
          this.tableClassifyData.unshift(objectAdaptor);
          this.timeSpcecailsFormData.treeChecked.push(checkedNodes[i].value)
        }
      }
      if(this.formPurpose=='edit'){
        //判断当前点击的节点是否为选中
        let isChecked=checkedNodes.find((item,index)=>{
          return currentClickNode==item;
        })
        if(isChecked){//选中
          this.tableClassifyData.unshift({
            value:currentClickNode.value,
            label:currentClickNode.label,
            classifyName:currentClickNode.label
          });
          this.timeSpcecailsFormData.treeChecked.push(currentClickNode.value)
        }else{//未选中
          let deleteIndex=this.tableClassifyData.findIndex((item)=>{
            return item.value==currentClickNode.value;
          })
          this.tableClassifyData.splice(deleteIndex,1);
        }
      }
    },
    //获取不参与的树状节点数据
    getCurrentNodesNoPart(currentClickNode,{checkedNodes}){
      if(this.formPurpose=='add'){
        this.tablenoClassifyData=[];
        this.timeSpcecailsFormData.notreeChecked=[];
        for(let i=0;i<checkedNodes.length;i++){
          let objectAdaptor={
            value:checkedNodes[i].value,
            label:checkedNodes[i].label,
            classifyName:checkedNodes[i].label,
          }
          this.tablenoClassifyData.unshift(objectAdaptor);
          this.timeSpcecailsFormData.notreeChecked.push(checkedNodes[i].value)
        }
      }
      if(this.formPurpose=='edit'){
        //判断当前点击的节点是否为选中
        let isChecked=checkedNodes.find((item,index)=>{
          return currentClickNode==item;
        })
        if(isChecked){//选中
          this.tablenoClassifyData.unshift({
            value:currentClickNode.value,
            label:currentClickNode.label,
            classifyName:currentClickNode.label,
          });
          this.timeSpcecailsFormData.notreeChecked.push(currentClickNode.value)
        }else{//未选中
          let deleteIndex=this.tablenoClassifyData.findIndex((item)=>{
            return item.value==currentClickNode.value;
          })
          this.tablenoClassifyData.splice(deleteIndex,1);
        }
      }
    },
    //计算折后价
    numberInputChange(row){
      row.disAfterPrice=Math.round(row.retailPrice*(row.promotionSale||0.00/10)*100)/100;
      return Math.round(row.retailPrice*( ((row.promotionSale||0.00)/10) )*100)/100;
    },
    //获取页面改行数据
    async getTableRow(id){
      this.currentRowId=id;
      let url=api.promotion.plan;
      let data={
        id:id
      }
      let tableRow={};
      await this.$axios.fetchGet(url,data).then((res)=>{
        if(res.code===200){
          tableRow=res.data;
        }else{
          this.$message.error('当前行获取失败!'+res.errorMsg);
        }
      })
      return tableRow;
    },
    // 终止
    stopTermination(row){
      this.$axios.fetchPost(api.promotion.termination,{id:row.id,status:40}).then((res)=>{
        if(res.code==200){
          // this.$message(
          //   {
          //     message: '终止成功',
          //     type:'success'
          //   }
          // )
          this.$notify({
            type: "success",
            title: '终止操作',
            message: '成功',
            showClose: false,
          });
          this.$refs.timeSpecialTable.getData()
        }else{
          this.$message.error(res.errorMsg)
        }
      })
    },
    //编辑
    async editPromotion(row,type){
      this.formPurpose='edit';
      let tableRow=await this.getTableRow(row.id);
      this.id=1;
      if(type){
        this.dialogTitle = '查看'
      }else{
        this.dialogTitle = '编辑'
      }
      let data={...tableRow};
      //编辑促销
      this.timedSpecialsVisible=true;
      this.editDisabled = true
      this.$nextTick(()=>{
        this.timeSpcecailsFormData={
          activityName:data.name||'',
          checkedCycle:false,
          nStartTime:data.startTime||'',
          nEndTime:data.endTime||'',
          startTime:'',
          endTime:'',
          rangeTimes:[
            {
              startTime:'',
              endTime:'',
            },
            {
              startTime:'',
              endTime:'',
            }
          ],
          detailList: this.localFieldShift('detailList','serve',data),//优惠层级
          cycleExe:'',
          everyWhat:'',//默认打开周期显示每天
          storesType:data.openStore?1:0,//适用门店默认全部门店
          channelHow:data.channelType?this.localFieldShift('channelType','serve',data):'A03',//适用渠道，默认线下
          applicableWho:data.userChannel?this.localFieldShift('userChannel','serve',data):'A01',//普适，默认全部用户
          applicableMember:Number(data.userChannelIds),//仅适用会员时选的会员
          puchaseWhat:data.openPurchase?'A02':'A01',//购买限制如何，默认不限
          puchaseCount:data.purchaseNum||0,//每人限购个数
          isListDiscount:false,//是否整单折扣
          isIntegral:data.openIntegral?'A01':'A02',//是否会员积分
          descripActivity:data.remarks||'',//活动说明
          participateWhat:data.participationType?this.localFieldShift('participationType','serve',data):'A01',//参与的商品radio,默认全部商品
          retailPrice:Number(data.special||'0'),//统一零售价
          noparticipateWhat:data.noParticipationType?this.localFieldShift('noParticipationType','serve',data):'A01',//不参与的商品radio，默认无
          takepartClassify:this.enumerationTakepartClassify,//用户可选的分类
          treeChecked:this.localFieldShift('categoryList','serve',data),//用户选择的类别
          notreeChecked:this.localFieldShift('noCategoryList','serve',data),//,
          seStoreIds:data.seStoreIds,//选择的指定门店
          storeIds:data.storeIds,//若为空，则是门店自己添加的活动，门店可以删除
          merchantId:data.merchantId,
          storeId:data.storeId,
          applicablePeople:[//适用人群可选项
            {
              label:'全部用户',
              id:'A01'
            },
            {
              label:'普通用户',
              id:'A02'
            },{
              label:'仅会员',
              id:'A03'
            },
          ],
          members:this.enumerationMembers,//适用会员可选项
          puchaseLimits:[
            {
              label:'不限',
              id:'A01'
            },
            {
              label:'每人每单每个商品限购(件/kg/箱)',
              id:'A02'
            }
          ],
          participateTypes:[
            // {label:'全部商品',id:'A01'},
            // {label:'指定分类',id:'A02'},
            {label:'指定商品',id:'A03'},
          ],
          noparticipateTypes:[
            {label:'无',id:'A01'},
            {label:'指定分类',id:'A02'},
            {label:'指定商品',id:'A03'},
          ],
          assignClassifys:this.enumerationAssignClassifys
        }
        this.tableDataP=this.localFieldShift('storeList','serve',data);
        this.tableinGoodsData=this.localFieldShift('goodsList','serve',data);
        this.tablenoGoodsData=this.localFieldShift('noGoodsList','serve',data);
        this.tableClassifyData=this.localFieldShift('categoryList2','serve',data);
      })
    },
    addTimedSpecials(){
      this.formPurpose='add';
      this.id=0;
      this.dialogTitle = '添加'
      if(this.$refs.timeSpcecailsForm){
        this.$refs.timeSpcecailsForm.resetFields() // 清空验证效果
      }
      this.timedSpecialsVisible=true;
      this.$nextTick(()=>{
        //初始化表单
        this.timeSpcecailsFormData={
          activityName:'',
          checkedCycle:false,
          nStartTime:'',
          nEndTime:'',
          startTime:'',
          endTime:'',
          rangeTimes:[
            {
              startTime:'',
              endTime:'',
            },
            {
              startTime:'',
              endTime:'',
            }
          ],
          //detailList
          // maxNum
          // subtractNum
          detailList:[//优惠层级
            {
              maxNum:0,
              subtractNum:0
            }
          ],
          cycleExe:'',
          everyWhat:'',//默认打开周期显示每天
          storesType:0,//适用门店默认全部门店
          channelHow:'A03',//适用渠道，默认线下
          applicableWho:'A01',//普适，默认全部用户
          applicableMember:'',//仅适用会员时选的会员
          puchaseWhat:'A01',//购买限制如何，默认不限
          puchaseCount:'',//每人限购个数
          isListDiscount:false,//是否整单折扣
          isIntegral:'A01',//是否会员积分
          descripActivity:'',//活动说明
          participateWhat:'A03',//参与的商品radio,默认全部商品
          retailPrice:Number('0'),//统一零售价
          noparticipateWhat:'A01',//不参与的商品radio，默认无
          takepartClassify:this.enumerationTakepartClassify,//用户可选的分类
          treeChecked:[],//用户选择的类别
          notreeChecked:[],//不参与 用户选择的类别
          seStoreIds:[],//选择的指定门店
          storeIds:'',//若为空，则是门店自己添加的活动，门店可以删除
          merchantId:'',
          storeId:'',
          applicablePeople:[//适用人群可选项
            {
              label:'全部用户',
              id:'A01'
            },
            {
              label:'普通用户',
              id:'A02'
            },{
              label:'仅会员',
              id:'A03'
            },
          ],
          members:this.enumerationMembers,//适用会员可选项
          puchaseLimits:[
            {
              label:'不限',
              id:'A01'
            },
            {
              label:'每人每单每个商品限购(件/kg/箱)',
              id:'A02'
            }
          ],
          participateTypes:[
            // {label:'全部商品',id:'A01'},
            // {label:'指定分类',id:'A02'},
            {label:'指定商品',id:'A03'},
          ],
          noparticipateTypes:[
            {label:'无',id:'A01'},
            {label:'指定分类',id:'A02'},
            {label:'指定商品',id:'A03'},
          ],
          assignClassifys:this.enumerationAssignClassifys
          // {
          //   value:'',
          //   label:'',
          //   classifyNum:'',
          //   classifyName:'',
          //   numberGoods:'',
          //   promotionSale:Number('0')
          // }
        };
        this.tableinGoodsData=[];
        this.tablenoGoodsData = []//不参与 指定商品清空
        this.tableClassifyData=[];
        this.tablenoClassifyData=[];//不参与 指定分类清空
      })

    },
    //字段转换，本地字段结构对服务端所需
    localFieldShift(field,where='local',data={}){
      let value;
      let arr;
      if(where==='local'){
        switch (field) {
          case 'channelHow'://适用渠道
            //全部
            if(this.timeSpcecailsFormData[field]==='A01'){
              value='30'
            }
            //线上
            if(this.timeSpcecailsFormData[field]==='A02'){
              value='10'
            }
            //线下
            if(this.timeSpcecailsFormData[field]==='A03'){
              value='20'
            }
            break;
          case 'applicableWho'://适用人群
            //全部
            if(this.timeSpcecailsFormData[field]==='A01'){
              value='10'
            }
            //普通用户
            if(this.timeSpcecailsFormData[field]==='A02'){
              value='20'
            }
            //会员
            if(this.timeSpcecailsFormData[field]==='A03'){
              value='30'
            }
            break;
          case 'participateWhat'://参与商品依据
            //全部
            if(this.timeSpcecailsFormData[field]==='A01'){
              value='10';
            }
            //指定分类
            if(this.timeSpcecailsFormData[field]==='A02'){
              value='20';
            }
            //指定商品
            if(this.timeSpcecailsFormData[field]==='A03'){
              value='30';
            }
            break;
          case 'noparticipateWhat':
            //全部
            if(this.timeSpcecailsFormData[field]==='A01'){
              value='10';
            }
            //指定分类
            if(this.timeSpcecailsFormData[field]==='A02'){
              value='20';
            }
            //指定商品
            if(this.timeSpcecailsFormData[field]==='A03'){
              value='30';
            }
            break;
          case 'tableDataP':
            arr=[];
            for(let i=0;i<this.tableDataP.length;i++){
              arr.push(this.tableDataP[i].id)
            }
            value=arr;
            break
          case 'detailList':
            arr=[];
            for(let i=0;i<this.timeSpcecailsFormData[field].length;i++){
              let objectAdaptor={
                maxNum:this.timeSpcecailsFormData[field][i].maxNum,
                subtractNum:this.timeSpcecailsFormData[field][i].subtractNum
              }
              arr.push(objectAdaptor);
            }
            value=arr;
            break;
          default:
            break;
        }
      }
      if(where==='serve'){
        switch (field) {
          case 'channelType'://适用渠道
            //线上
            if(String(data[field])=='10'){
              value='A02'
            }
            //线下
            if(String(data[field])=='20'){
              value='A03'
            }
            //全部
            if(String(data[field])=='30'){
              value='A01'
            }
            break;
          case 'userChannel'://适用人群
            //全部
            if(String(data[field])=='10'){
              value='A01'
            }
            //普通用户
            if(String(data[field])=='20'){
              value='A02'
            }
            //会员
            if(String(data[field])=='30'){
              value='A03'
            }
            break;
          case 'participationType'://参与商品依据
            //全部
            if(String(data[field])=='10'){
              value='A01'
            }
            //指定分类
            if(String(data[field])=='20'){
              value='A02'
            }
            //指定商品
            if(String(data[field])=='30'){
              value='A03'
            }
            break;
          case 'noParticipationType'://不参与商品依据
            //全部
            if(String(data[field])=='10'){
              value='A01'
            }
            //指定分类
            if(String(data[field])=='20'){
              value='A02'
            }
            //指定商品
            if(String(data[field])=='30'){
              value='A03'
            }
            break;
          case 'storeList':
            let arr=this.$utils.getCacheStatus('seStore.storeClass');
            value=[];
            if(data[field])
              for(let i=0;i<data[field].length;i++){
                let objectAdaptor={
                  id:data[field][i].id,
                  serialNumber:data[field][i].code,
                  storyName:data[field][i].name,
                  storesType:data[field][i].storeClass,
                }
                let store=arr.find((item)=>{
                  return item.value===data[field][i].storeClass;
                })
                objectAdaptor.storesType=store.label
                value.push(objectAdaptor);
              }
            break;
          case 'goodsList':
            value=[];
            if(data[field])
              for(let i=0;i<data[field].length;i++){
                let objectAdaptor={
                  index:i+1,
                  barCode:data[field][i].barCode,
                  goodsName:data[field][i].name,
                  purchasingPrice:data[field][i].purchasePrice,
                  retailPrice:data[field][i].retailPrice,
                  promotionSale:Number(data[field][i].promotionSale)
                }
                value.push(objectAdaptor);
              }
            break
          case 'noGoodsList':
            value=[];
            if(data[field])
              for(let i=0;i<data[field].length;i++){
                let objectAdaptor={
                  index:i+1,
                  barCode:data[field][i].barCode,
                  goodsName:data[field][i].name,
                  purchasingPrice:data[field][i].purchasePrice,
                  retailPrice:data[field][i].retailPrice,
                  promotionSale:Number(data[field][i].promotionSale)
                }
                value.push(objectAdaptor);
              }
            break;
          case 'categoryList':
            value=[];
            if(data[field])
              for(let i=0;i<data[field].length;i++){
                value.push(data[field][i].value);
              }
            break;
          case 'categoryList2':
            value=[];
            if(data.categoryList)
              for(let i=0;i<data.categoryList.length;i++){
                let objectAdaptor={
                  value:data.categoryList[i].value,
                  label:data.categoryList[i].label,
                  classifyNum:'1101',
                  classifyName:data.categoryList[i].label,
                  numberGoods:'10',
                  promotionSale:Number(data.categoryList[i].promotionSale)
                }
                value.push(objectAdaptor)
              }
            break;
          case 'noCategoryList':
            value=[];
            if(data[field])
              for(let i=0;i<data[field].length;i++){
                value.push(data[field][i].value);
              }
            break
          case 'detailList':
            value=[];
            if(data[field])
              for(let i=0;i<data[field].length;i++){
                let objectAdaptor={
                  maxNum:Number(data[field][i].maxNum).toFixed(2),
                  subtractNum:Number(data[field][i].subtractNum).toFixed(2)
                }
                value.push(objectAdaptor);
              }
          default:
            break;
        }
      }
      return value;
    },
    //不能等此单选框组值变了才响应事件，现在马上立刻。
    participateWhatClick(val,item,isParticipate){
      if(val!='INPUT') return ;
      this.isParticipate = isParticipate
      if(isParticipate==='participate'){
        this.tableinGoodsData = [] // 指定商品清空
        this.tableClassifyData=[];// 指定分类清空
        this.timeSpcecailsFormData.treeChecked=[]//指定分类 选中清空
        switch (item.id) {
          case 'A01'://参与为全部，不参与类型置为默认项无
            this.timeSpcecailsFormData.noparticipateWhat = 'A01'
            break;
          case 'A02'://参与为指定分类，不参与类型置为默认项无
            this.timeSpcecailsFormData.noparticipateWhat='A01'
            break;
          case 'A03'://只要点击指定商品就要弹出框。并且不参与类型置为默认项
            if(this.timeSpcecailsFormData.nEndTime&&this.timeSpcecailsFormData.nStartTime){
              this.selectGoodsVisible = true;
              this.selectGoods = this.tableGoodsData;
              this.tableGoodsData = this.tableinGoodsData;//弹出窗表格的显示就是不靠值变了才显示。
              this.searchParams={
                stCreateDttm:this.timeSpcecailsFormData.nStartTime,
                edCreateDttm:this.timeSpcecailsFormData.nEndTime
              }
            }else{
              this.$message({
                type:'warning',
                message:'请先选择活动开始时间和结束时间！',
              })
            }
            break;
          default:
            break;
        }
      }
      if(isParticipate==='noparticipate'){
        this.tablenoGoodsData = []//不参与 指定商品清空
        this.tablenoClassifyData=[];//不参与 指定分类清空
        this.timeSpcecailsFormData.notreeChecked=[]//不参与 选中指定分类清空
        switch (item.id) {
          case 'A03'://只要点击指定商品就要弹出框
            this.selectGoodsVisible=true;
            this.tableGoodsData=this.tablenoGoodsData;
            break;

          default:
            break;
        }
      }
    },
    //多选select选中的对象
    classify(currentClassifyList){
      console.log('========',currentClassifyList)
      let tempAssignClassifys=this.timeSpcecailsFormData.assignClassifys.filter((assignClassifyItem,index)=>{
        for(let i=0;i<currentClassifyList.length;i++){
          if(currentClassifyList[i]==assignClassifyItem.value){
            return true;
          }
        }
      })
      this.tableClassifyData=[...tempAssignClassifys];
    },
    btnCallback(operatorType,row){
      console.log('操作回调',operatorType,row)
      switch (operatorType) {
        case 'delete':
          let deleteIndex=this.tableDataP.findIndex((item)=>{
            return item.serialNumber===row.serialNumber;
          })
          this.tableDataP.splice(deleteIndex,1);
          break;

        default:
          break;
      }
    },
    btnCallback2(operatorType,row){
      console.log('操作回调2',operatorType)
      switch (operatorType) {
        case 'delete':
          for(let i=0;i<this.tableClassifyData.length;i++){
            if(row==this.tableClassifyData[i]){
              this.tableClassifyData.splice(i,1);
              break;
            }
          }
          //反选勾掉树状结构选项
          let tempTreeChecked=[...this.timeSpcecailsFormData.treeChecked];
          for(let j=0;j<tempTreeChecked.length;j++){
            if(row.value==this.timeSpcecailsFormData.treeChecked[j]){
              this.timeSpcecailsFormData.treeChecked.splice(j,1);
            }
          }

          this.$refs.treeForm.setCheckedKeys(this.timeSpcecailsFormData.treeChecked);
          break;

        default:
          break;
      }
    },
    btnCallback3(operatorType,row){
      console.log('操作回调3',operatorType)
      switch (operatorType) {
        case 'delete':
          for(let i=0;i<this.tableinGoodsData.length;i++){
            if(row==this.tableinGoodsData[i]){
              this.tableinGoodsData.splice(i,1);
              break;
            }
          }
          break;

        default:
          break;
      }
    },
    btnCallback4(operatorType,row){
      console.log('操作回调4',operatorType)
      switch (operatorType) {
        case 'delete':
          for(let i=0;i<this.tablenoGoodsData.length;i++){
            if(row==this.tablenoGoodsData[i]){
              this.tablenoGoodsData.splice(i,1);
              break;
            }
          }
          break;

        default:
          break;
      }
    },
    //添加执行时间段
    addTimeRang(){
      this.timeSpcecailsFormData.rangeTimes.push({startTime:'',endTime:''});
    },
    //添加满减层级
    addPreferentialLevels(){
      if(this.timeSpcecailsFormData.detailList.length<5){
        this.timeSpcecailsFormData.detailList.push({maxNum:0,subtractNum:0});
      }

    },
    refontSize() {
      document.documentElement.style.fontSize =
        (document.documentElement.clientWidth / 1920) * 10 + "px";
    },
    //初始化一些枚举数据
    getAllEnumeration(){
      const loading=this.$loading();
      //会员可选项
      let url=api.member.category+'/list';
      this.$axios.fetchPost(url).then((res)=>{
        this.timeSpcecailsFormData.members=[];
        if(res.code===200){
          for(let i=0;i<res.data.length;i++){
            let objectAdaptor={
              label:res.data[i].name||'脏数据',
              id:res.data[i].id
            }
            this.timeSpcecailsFormData.members.push(objectAdaptor);
          }
          this.enumerationMembers=[...this.timeSpcecailsFormData.members];
        }else{
          this.$message.error('会员种类拉取错误!'+res.errorMsg);
        }
      })
      //商品类别树状可选项
      url=api.archives.getCategoryTree+'/list';
      this.$axios.fetchPost(url).then((res)=>{
        loading.close();
        this.timeSpcecailsFormData.takepartClassify=[];
        if(res.code===200){
          this.enumerationTakepartClassify=res.data;
        }else{
          this.$message.error('会员种类拉取错误!'+res.errorMsg);
        }
      })
    }
  },

}
</script>

<style scoped>
.timeCycle{
  background-color: #f2f2f2;
  width: 100%;
  margin-top: 10px;
  padding-top: 10px;
  margin-bottom: 30px;
}

.timeRangArea{
  margin-bottom:10px;
}

.someStores{
  margin-top: 10px;
  margin-bottom: 30px;
}

.takepartAll{
  padding: 10px;
  height: 52px;
  background-color: #f2f2f2;
  display: flex;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 30px;
}

.classifyTree{
  max-height: 200px;
  overflow: auto;
}

.preferentialLevels{
  display: flex;
  flex-flow: row nowrap;
  margin-bottom: 10px;
  align-items: center;
}

.iconArea{
  color: #666;
  padding: 0 6px;
  min-width: 24px;
  background-color: #eff3f6;
  border:1px solid rgb(218, 218, 218);
  height: 28px;
  line-height: 28px;
}
.footerBtn{
  text-align: center;
}

.timedSpecials .takepartClassify .el-select{
  height: none;
}

.timedSpecials .el-select .el-select__tags .el-tag.el-tag--info{
  width:78px;
}
>>> .el-select__tags .el-tag.el-tag--info{
  padding-right:18px;
  max-width: unset;
}
>>> .el-tag.el-tag--info .el-tag__close{
  right:1px;
}
</style>



// WEBPACK FOOTER //
// src/page/promotion/promotionTool/FullReduction.vue